module.exports = __webpack_public_path__ + "img/section3_pic1@3x.cd247431.png";